import PropTypes from 'prop-types';
import Image from '../Image/Image';

const ImageFigure = {};

ImageFigure.propTypes = Object.assign({}, Image.propTypes, {
    caption: PropTypes.string,
    photographer: PropTypes.string
});

export default ImageFigure;



// WEBPACK FOOTER //
// ./src/components/Models/ImageFigure/ImageFigure.jsx